"use strict";
// (C) 2019-2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDashboard = exports.convertDashboardDateFilterConfig = exports.convertListedDashboard = void 0;
var tslib_1 = require("tslib");
var api_model_bear_1 = require("@gooddata/api-model-bear");
var sdk_model_1 = require("@gooddata/sdk-model");
var keyBy_1 = tslib_1.__importDefault(require("lodash/keyBy"));
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var filterContext_1 = require("./filterContext");
var layout_1 = require("./layout");
var widget_1 = require("./widget");
exports.convertListedDashboard = function (dashboardLink, availability, userMap) {
    var _a, _b;
    var isUnderStrictControlProp = dashboardLink.flags && dashboardLink.flags.findIndex(function (flag) { return flag === "strictAccessControl"; }) !== -1
        ? {
            isUnderStrictControl: true,
        }
        : {};
    return tslib_1.__assign({ ref: sdk_model_1.uriRef(dashboardLink.link), identifier: dashboardLink.identifier, uri: dashboardLink.link, title: dashboardLink.title, description: dashboardLink.summary, updated: dashboardLink.updated, updatedBy: dashboardLink.contributor ? userMap === null || userMap === void 0 ? void 0 : userMap.get(dashboardLink.contributor) : undefined, created: dashboardLink.created, createdBy: dashboardLink.author ? userMap === null || userMap === void 0 ? void 0 : userMap.get(dashboardLink.author) : undefined, 
        // filter takes care of multiple spaces and also the base scenario ("" ~> [])
        tags: (_b = (_a = dashboardLink.tags) === null || _a === void 0 ? void 0 : _a.split(" ").filter(Boolean)) !== null && _b !== void 0 ? _b : [], isLocked: !!dashboardLink.locked, shareStatus: getShareStatus(!!dashboardLink.unlisted, !!dashboardLink.sharedWithSomeone), availability: availability }, isUnderStrictControlProp);
};
var convertDateFilterConfigAddedPresets = function (addPresets) {
    var _a = addPresets.absolutePresets, absolutePresets = _a === void 0 ? [] : _a, _b = addPresets.relativePresets, relativePresets = _b === void 0 ? [] : _b;
    return {
        absolutePresets: absolutePresets.map(function (preset) { return (tslib_1.__assign(tslib_1.__assign({}, preset), { type: "absolutePreset" })); }),
        relativePresets: relativePresets.map(function (preset) { return (tslib_1.__assign(tslib_1.__assign({}, preset), { type: "relativePreset" })); }),
    };
};
exports.convertDashboardDateFilterConfig = function (dateFilterConfig) {
    var filterName = dateFilterConfig.filterName, mode = dateFilterConfig.mode, addPresets = dateFilterConfig.addPresets, hideGranularities = dateFilterConfig.hideGranularities, hideOptions = dateFilterConfig.hideOptions;
    return {
        filterName: filterName,
        mode: mode,
        addPresets: addPresets && convertDateFilterConfigAddedPresets(addPresets),
        hideGranularities: hideGranularities,
        hideOptions: hideOptions,
    };
};
var convertPluginLink = function (link) {
    var type = link.type, parameters = link.parameters;
    return {
        type: "IDashboardPluginLink",
        plugin: sdk_model_1.uriRef(type),
        parameters: parameters,
    };
};
var getShareStatus = function (unlisted, sharedWithSomeone) {
    if (unlisted && !sharedWithSomeone) {
        return "private";
    }
    else if (unlisted && sharedWithSomeone) {
        return "shared";
    }
    else {
        return "public";
    }
};
exports.convertDashboard = function (dashboard, dependencies, visualizationClasses, exportFilterContextUri, userMap) {
    var _a;
    if (visualizationClasses === void 0) { visualizationClasses = []; }
    var _b = dashboard.analyticalDashboard, _c = _b.meta, summary = _c.summary, created = _c.created, author = _c.author, updated = _c.updated, contributor = _c.contributor, identifier = _c.identifier, uri = _c.uri, title = _c.title, locked = _c.locked, tags = _c.tags, unlisted = _c.unlisted, sharedWithSomeone = _c.sharedWithSomeone, flags = _c.flags, _d = _b.content, layout = _d.layout, filterContext = _d.filterContext, dateFilterConfig = _d.dateFilterConfig, widgetsUris = _d.widgets, plugins = _d.plugins;
    var sdkDependencies = dependencies
        // Filter out visualization objects - we only need them to create implicit layout
        .filter(function (d) { return !api_model_bear_1.GdcVisualizationObject.isVisualization(d); })
        .map(convertDashboardDependency);
    var unsortedWidgets = sdkDependencies.filter(sdk_backend_spi_1.isWidget);
    // To preserve the logic of createImplicitDashboardLayout, we must preserve the order of the widgets
    var widgetByUri = keyBy_1.default(unsortedWidgets, "uri");
    var widgets = widgetsUris.map(function (widgetUri) { return widgetByUri[widgetUri]; });
    var filterContextOrExportFilterContext = sdkDependencies.find(function (dep) {
        return exportFilterContextUri ? dep.uri === exportFilterContextUri : dep.uri === filterContext;
    });
    var isUnderStrictControlProp = flags && flags.findIndex(function (flag) { return flag === "strictAccessControl"; }) !== -1
        ? {
            isUnderStrictControl: true,
        }
        : {};
    return tslib_1.__assign(tslib_1.__assign({ type: "IDashboard", title: title, description: summary, identifier: identifier, uri: uri, ref: sdk_model_1.uriRef(uri), created: created, createdBy: author ? userMap === null || userMap === void 0 ? void 0 : userMap.get(author) : undefined, updated: updated, updatedBy: contributor ? userMap === null || userMap === void 0 ? void 0 : userMap.get(contributor) : undefined, isLocked: !!locked, shareStatus: getShareStatus(!!unlisted, !!sharedWithSomeone) }, isUnderStrictControlProp), { dateFilterConfig: dateFilterConfig && exports.convertDashboardDateFilterConfig(dateFilterConfig), filterContext: exportFilterContextUri && filterContextOrExportFilterContext
            ? filterContext_1.sanitizeExportFilterContext(filterContextOrExportFilterContext)
            : filterContextOrExportFilterContext, layout: layout
            ? layout_1.convertLayout(layout, widgets)
            : layout_1.createImplicitDashboardLayout(widgets, dependencies, visualizationClasses), plugins: plugins === null || plugins === void 0 ? void 0 : plugins.map(convertPluginLink), 
        // filter takes care of multiple spaces and also the base scenario ("" ~> [])
        tags: (_a = tags === null || tags === void 0 ? void 0 : tags.split(" ").filter(function (t) { return t; })) !== null && _a !== void 0 ? _a : [] });
};
var convertDashboardDependency = function (dependency) {
    if (api_model_bear_1.GdcVisualizationWidget.isWrappedVisualizationWidget(dependency)) {
        return widget_1.convertVisualizationWidget(dependency);
    }
    else if (api_model_bear_1.GdcKpi.isWrappedKpi(dependency)) {
        return widget_1.convertKpi(dependency);
    }
    else if (api_model_bear_1.GdcFilterContext.isWrappedFilterContext(dependency)) {
        return filterContext_1.convertFilterContext(dependency);
    }
    else if (api_model_bear_1.GdcFilterContext.isWrappedTempFilterContext(dependency)) {
        return filterContext_1.convertTempFilterContext(dependency);
    }
    throw new Error("No converter for the dashboard dependency!");
};
//# sourceMappingURL=dashboards.js.map